/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import DOMPurify from 'dompurify';
// import { XssSafeContent } from '@squiz/xaccel-xss-safe-content';

import styles from '../../css/functional.module.scss';

const generateOrganicSuggestion = ({
    parentId,
    index,
    isActive,
    // eslint-disable-next-line no-unused-vars
    data: { key, disp, disp_t: dispType, wt, cat, cat_t: catType, action, action_t: actionType },
    setInputValue,
    inputValue,
    onSubmit,
}) => {
    let displayValue = '';
    // const sefeInputValue = <XssSafeContent content={inputValue} elementType="span" className="search-box__autocomplete-query" />;

    const itemId = `${parentId}-${key}-${index}`.replace(/\s/g, '-');
    const regex = new RegExp(`(${inputValue})`, 'gi');
    const highlight = `<span class="search-box__highlight">$1</span>`;

    if (dispType === 'T') {
        displayValue = disp; // Is a text value
    } else if (dispType === 'J') {
        displayValue = JSON.stringify(disp); // Is a JSON object
    }

    // const safeDisplayValue = <XssSafeContent content={displayValue} elementType="span" />;

    const item = displayValue.replace(regex, highlight);
    const cleanHtml = DOMPurify.sanitize(item);

    return (
        // This is all handled by the assisted-input components so errors are incorrect in this case
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus
        <div
            role="row"
            key={itemId}
            id={itemId}
            data-active={isActive}
            onClick={(e) => {
                if (actionType === 'S') {
                    // S for system generated auto completion
                    setInputValue({ value: key });
                } else if (actionType === 'U') {
                    // U for opening an URL
                    e.preventDefault();
                    window.open(action, '_blank');
                } else if (actionType === 'Q') {
                    // Q for running a query
                    setInputValue({ value: action });
                    setTimeout(() => {
                        onSubmit();
                    }, 10);
                }
            }}
            className={`search-box-source__item ${styles.searchBoxSourceItem}`}
        >
            {actionType === 'Q' && (
                <>
                    <svg aria-label="Query" className={`search-box__icon ${styles.searchBoxIcon}`}>
                        <use href="#arrow" />
                    </svg>
                    {/* <XssSafeContent content={item} elementType="span" className="search-box__source-item" /> */}
                    <span
                        className={`search-box-source__label ${styles.searchBoxSourceLabel}`}
                        dangerouslySetInnerHTML={{ __html: cleanHtml }}
                    />
                </>
            )}
            {actionType === 'U' && (
                <a
                    title={key}
                    target="_blank"
                    href={action}
                    tabIndex={-1}
                    className={`search-box-source__link ${styles.searchBoxSourceLink}`}
                    rel="noreferrer"
                >
                    <svg aria-label="Open in new window" className={`search-box__icon ${styles.searchBoxIcon}`}>
                        <use href="#external" />
                    </svg>
                    {/* <XssSafeContent content={item} elementType="span" className="search-box__source-item" /> */}
                    <span
                        className={`search-box-source__label ${styles.searchBoxSourceLabel}`}
                        dangerouslySetInnerHTML={{ __html: cleanHtml }}
                    />
                </a>
            )}

            {actionType !== 'Q' && actionType !== 'U' && (
                <span
                    className={`search-box-source__label ${styles.searchBoxSourceLabel}`}
                    dangerouslySetInnerHTML={{ __html: cleanHtml }}
                />
            )}
        </div>
    );
};

export default generateOrganicSuggestion;
